import { TranslationString } from '../localization';

export type ScenarioFolderServer = {
  _id: string;
  name: string;
  date_created: string;
  date_updated: string;
};

export enum ScenarioFolderError {
  scenarioFolderAlreadyExists = 'scenario_folder_already_exists'
}

export const mapScenarioFolderCreateErrorToMessage =
  (code: ScenarioFolderError): TranslationString =>
  (t) =>
    t(`scenarioFolder.errors.${code}`, {
      ns: 'entities'
    });

export enum ScenarioFolderDeleteAction {
  move = 'move',
  delete = 'delete'
}

export type ScenarioFolderDeleteParams = {
  _id: string;
} & (
  | {
      action: ScenarioFolderDeleteAction.move;
      move_to_folder_id: string | null;
    }
  | {
      action: ScenarioFolderDeleteAction.delete;
    }
);
